import React, { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";
import { API_BASE } from "../api.js";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [artist, setArtist] = useState(() => {
    try {
      const raw = localStorage.getItem("spar-artist");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  const login = useCallback(async (loginField, password) => {
    const res = await axios.post(`${API_BASE}/login`, { login: loginField, password });
    const { token: newToken, artist: newArtist } = res.data;
    localStorage.setItem("token", newToken);
    localStorage.setItem("spar-artist", JSON.stringify(newArtist));
    setToken(newToken);
    setArtist(newArtist);
    return newArtist;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("spar-artist");
    setToken(null);
    setArtist(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{ token, artist, isLoggedIn: !!token, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
